import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { Auth } from '../../../../autentication/Auth';
import { Util } from '../../../../utils/util';
import { PixReceipt } from '../../models/receipt.model';
import { PixRefundService } from '../refund.service';

@Component({
	selector: 'app-pix-refund-resume-final',
	templateUrl: './resume-final.component.html',
	styleUrls: ['./resume-final.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PixRefundResumeFinalComponent implements OnInit {
	public receipt: PixReceipt;
	public meuNome: string;
	public meuCpfCnpj: string;

	constructor(
		private router: Router,
		private refundService: PixRefundService
	) {}

	ngOnInit(): void {
		this.receipt = this.refundService.getPixReceipt();
		console.log(this.receipt.complemento, 'pixReceipt');
		this.meuNome = Auth.getInstance().getUser().name;
		this.meuCpfCnpj = Auth.getInstance().getUser().cpf;
		if (this.invalidParams()) {
			this.goBack();
		}
	}

	invalidParams(): boolean {
		return this.receipt === undefined ||
			this.receipt.valor === undefined ||
			this.receipt.nome === undefined;
	}

	generate() {}

	goBack() {
		this.router.navigate(['pix/']);
	}

	emitPrint() {
		window.print();
	}

	getCpfCnpj(cpfCnpj: string) {
		return Util.maskCpfCnpjPix(cpfCnpj);
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/pix/refund/resume-final/resume-final.component.ts